import { useEffect, useState } from "react";
import { Loader2, Inbox, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "—");

export function UnassignedWebhooks({ tenants }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState("");
  const [choice, setChoice] = useState({});
  const load = () => api.get("/superadmin/webhook-events/unassigned").then((r) => setD(r.data)).catch(() => setD({ events: [], total: 0 }));
  useEffect(() => { load(); }, []);
  const assign = async (ev) => {
    const tid = choice[ev.id];
    if (!tid) return toast.error("Scegli il canale di destinazione");
    setBusy(ev.id);
    try {
      const { data } = await api.post(`/superadmin/webhook-events/${ev.id}/assign`, { tenant_id: tid });
      toast.success(`Evento assegnato a «${tid}» · stato ${data.event?.status}`);
      await load();
    } catch (e) { toast.error(e.response?.data?.detail || "Assegnazione non riuscita"); } finally { setBusy(""); }
  };
  if (!d) return <div className="p-4 flex justify-center"><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div>;
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-2" data-testid="sa-unassigned-webhooks">
      <div className="flex items-center gap-2">
        <Inbox className="h-4 w-4 text-slate-500" />
        <p className="text-sm font-semibold text-slate-800">Webhook Meta non assegnati <span className="text-slate-500 font-normal" data-testid="sa-unassigned-count">({d.total})</span></p>
        <Button size="sm" variant="outline" onClick={load} className="ml-auto h-7" data-testid="sa-unassigned-refresh"><RefreshCw className="h-3.5 w-3.5" /></Button>
      </div>
      <p className="text-xs text-slate-500">Eventi ricevuti da numeri o WABA che nessun canale dichiara: non vengono mai scritti nei dati del canale principale. Assegnali al canale corretto per elaborarli.</p>
      {!d.events.length && <p className="text-sm text-slate-500" data-testid="sa-unassigned-empty">Nessun evento in attesa.</p>}
      {d.events.map((ev) => (
        <div key={ev.id} className="flex flex-wrap items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-xs" data-testid={`sa-unassigned-${ev.id}`}>
          <span className="text-slate-500">{fmt(ev.received_at)}</span>
          <span className="text-slate-800">tipi: {(ev.kinds || []).join(", ") || "—"}</span>
          <span className="text-slate-500">numeri {(ev.phone_number_ids || []).join(", ") || "—"} · WABA {(ev.waba_ids || []).join(", ") || "—"}</span>
          <select value={choice[ev.id] || ""} onChange={(e) => setChoice({ ...choice, [ev.id]: e.target.value })} className="ml-auto h-7 rounded border border-slate-200 bg-white px-2 text-xs" data-testid={`sa-unassigned-select-${ev.id}`}>
            <option value="">Canale…</option>
            {(tenants || []).map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
          <Button size="sm" disabled={busy === ev.id} onClick={() => assign(ev)} className="h-7 text-xs bg-slate-900 text-white" data-testid={`sa-unassigned-assign-${ev.id}`}>{busy === ev.id ? <Loader2 className="h-3 w-3 animate-spin" /> : "Assegna"}</Button>
        </div>
      ))}
    </div>
  );
}
